export default __webpack_public_path__ + "static/s2-10d7c230c9bb721602def6d61cd508a7.jpg";